module.exports = __webpack_public_path__ + "img/icon24.5d55c2a5.png";